/**
 * Lazy load Chart.js and Chartkick only when charts are actually rendered
 * This saves ~400KB from the initial bundle
 */

let chartkickLoaded = false

export async function loadChartkick() {
  if (chartkickLoaded) return
  
  // Dynamic import - this creates a separate chunk
  await import("chartkick/chart.js")
  chartkickLoaded = true
}

// Auto-initialize when chart elements are detected
if (typeof document !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            // Check if the added node or any of its children contain a Chartkick chart
            if (node.matches('[id^="chart-"]') || node.querySelector('[id^="chart-"]')) {
              loadChartkick()
              observer.disconnect() // Only load once
            }
          }
        })
      }
    }
  })

  // Start observing when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true })
      
      // Also check if charts already exist
      if (document.querySelector('[id^="chart-"]')) {
        loadChartkick()
        observer.disconnect()
      }
    })
  } else {
    observer.observe(document.body, { childList: true, subtree: true })
    
    // Check if charts already exist
    if (document.querySelector('[id^="chart-"]')) {
      loadChartkick()
      observer.disconnect()
    }
  }
}
